import Reveal from './Reveal';

export default function SectionHeading({ eyebrow, title, intro, dark = false, className = '', testid }) {
  return (
    <Reveal className={`max-w-3xl ${className}`}>
      {eyebrow && (
        <p
          className={`font-mono text-xs font-semibold uppercase tracking-[0.2em] ${
            dark ? 'text-lime' : 'text-stonebrand'
          }`}
        >
          {eyebrow}
        </p>
      )}
      <h2
        data-testid={testid}
        className={`mt-4 text-balance font-heading text-2xl font-bold leading-snug tracking-tight sm:text-3xl lg:text-4xl ${
          dark ? 'text-offwhite' : 'text-charcoal'
        }`}
      >
        {title}
      </h2>
      {intro && (
        <p className={`mt-5 text-base leading-relaxed sm:text-lg ${dark ? 'text-offwhite/70' : 'text-stonebrand'}`}>
          {intro}
        </p>
      )}
    </Reveal>
  );
}
